import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { ToastrService } from 'ngx-toastr';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-cameraman-workflow',
  templateUrl: './cameraman-workflow.component.html',
  styleUrls: ['./cameraman-workflow.component.css']
})
export class CameramanWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'CAMERAMAN_ASSIGNED': 'Cameraman Assigned',
    'CAMERAMAN_COMPLETED': 'Cameraman Completed',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  cameramanForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  loggedInUserId: any;

  userList: any[] = [];
  editorUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  videoUrl: any = videoURL
  userType: any;

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.initForm();
    this.userType = sessionStorage.getItem("userType");
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
    this.getAllUsers();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'CAMERA_MAN_NOTE');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.userList = res.response;
          this.editorUserList = this.userList.filter((u: any) => u.userType === 'EDITOR');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  initForm() {
    this.cameramanForm = this.fb.group({
      cameraManUser: [''],
      assignToCameraManOnDate: [''],
      cameraManStartDate: [''],
      cameraManEndDate: [''],
      noOfDaysWithCameraman: [''],
      noOfHoursWithCameraman: [''],
      commonNotes: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'CAMERAMAN');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  openCameramanModal(episode: any) {
    this.selectedEpisode = episode;
    this.cameramanForm.patchValue({
      ...episode,
      commonNotes: ''
    });
    this.formSubmit = false;
    this.selectedUserIdToAssign = "";
  }

  closeModal() {
    document.getElementById("closeCameramanModalBtn")?.click();
    this.selectedEpisode = null;
    this.cameramanForm.reset();
    this.selectedUserIdToAssign = "";
  }

  saveDetails(complete: boolean) {
    if (this.cameramanForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.cameramanForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.cameramanForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    if (complete && this.selectedUserIdToAssign) {
      nextStage = "EDITOR";
    }

    let finalEndDate = this.cameramanForm.get('cameraManEndDate').value ? new Date(this.cameramanForm.get('cameraManEndDate').value).getTime() : 0;
    let finalNoOfDays = this.cameramanForm.get('noOfDaysWithCameraman').value || 0;
    let finalNoOfHours = this.cameramanForm.get('noOfHoursWithCameraman').value || 0;
    let finalStartDate = this.cameramanForm.get('cameraManStartDate').value ? new Date(this.cameramanForm.get('cameraManStartDate').value).getTime() : this.selectedEpisode.cameraManStartDate;

    if (complete) {
      finalEndDate = new Date().getTime();
      if (finalStartDate) {
        const diffMs = finalEndDate - finalStartDate;
        finalNoOfDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
        finalNoOfHours = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60)));
      }
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      cameraManUser: this.cameramanForm.get('cameraManUser').value,
      assignToCameraManOnDate: this.cameramanForm.get('assignToCameraManOnDate').value ? new Date(this.cameramanForm.get('assignToCameraManOnDate').value).getTime() : (this.selectedEpisode.assignToCameraManOnDate || 0),
      cameraManStartDate: finalStartDate || 0,
      cameraManEndDate: finalEndDate,
      noOfDaysWithCameraman: finalNoOfDays,
      noOfHoursWithCameraman: finalNoOfHours,
      episodeStatus: complete ? 'CAMERAMAN_COMPLETED' : (complete && this.selectedUserIdToAssign ? 'EDITOR_ASSIGNED' : this.selectedEpisode.episodeStatus),
      currentStage: nextStage,
      editorUser: (complete && this.selectedUserIdToAssign) ? this.selectedUserIdToAssign : this.selectedEpisode.editorUser,
      assignedUserId: (complete && this.selectedUserIdToAssign) ? Number(this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId || 0) : (this.selectedEpisode.assignedUserId || 0),
      assignToEditorOnDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.assignToEditorOnDate,
      editStartDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.editStartDate,
      editDueDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() + (2 * 24 * 60 * 60 * 1000) : this.selectedEpisode.editDueDate,
      cid: this.cid
    };

    if (complete && this.selectedUserIdToAssign) {
      payload.episodeStatus = 'EDITOR_ASSIGNED';
    }

    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
          this.getAllEpisodes();
        } else {
          this.getAllTvProductionTrackersUserId();
        }
        this.closeModal();
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.cameramanForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.cameramanForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
